import React from 'react'
import {
  WidgetLoadingGuard,
  ThemeInaccessibleGuard,
  TopicIndexNotReadyGuard
} from 'components/widget/share/guards'
import { WidgetGuard } from 'features/types'

import SideBySideLowCountGuard from './SideBySideLowCountGuard'
import SideBySideEmptyResultGuard from './SideBySideEmptyResultGuard'
import SideBySideLanguageNotSupportGuard from './SideBySideLanguageNotSupportGuard'

const PostSearchDataGuards: WidgetGuard = ({ widgetId, children }) => (
  <WidgetLoadingGuard widgetId={widgetId}>
    <TopicIndexNotReadyGuard widgetId={widgetId}>
      <ThemeInaccessibleGuard widgetId={widgetId}>
        <SideBySideLowCountGuard widgetId={widgetId}>
          <SideBySideLanguageNotSupportGuard widgetId={widgetId}>
            <SideBySideEmptyResultGuard widgetId={widgetId}>{children}</SideBySideEmptyResultGuard>
          </SideBySideLanguageNotSupportGuard>
        </SideBySideLowCountGuard>
      </ThemeInaccessibleGuard>
    </TopicIndexNotReadyGuard>
  </WidgetLoadingGuard>
)

export default PostSearchDataGuards
